export const FILE_TYPE_ERROR = 'Выбран недопустимый формат файла. Загрузите файл в формате JPG, PNG, WEBP';
export const FILE_SIZE_ERROR = 'Загрузите документ меньше 5мб';
export const FILE_LIMIT_ERROR =
  'Загружено максимальное количество изображений. \nУдалите или отредактируйте одно из загруженных ранее.';

export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const MAX_FILE_SIZE_MB = MAX_FILE_SIZE / 1024 / 1024;
